import { Fragment } from "react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import TooltipComponent from "components/ui/tooltip/Tooltip";
import { PlanSection } from "./subscriptionPlanDetailsConfig";

import css from "./SimplePlanComparisonTable.module.scss";

export const SimplePlanComparisonTable = ({ sections }: { sections: PlanSection[] }) => {
  return (
    <tbody>
      {sections.map((section) => (
        <Fragment key={section.header}>
          <tr className={css.headerRow}>
            <HeaderText>{section.header}</HeaderText>
            <th />
            <th />
            <th />
            <th />
          </tr>
          {section.features.map((feature) => (
            <TableRow key={feature.feature}>
              <FeatureTextCell scope="row">
                <TooltipComponent content={feature.tooltip} side="left" delayDuration={0}>
                  <FeatureText hasTooltip={!!feature.tooltip}>{feature.feature}</FeatureText>
                </TooltipComponent>
              </FeatureTextCell>
              <FeatureStatusCell>{feature.forFree}</FeatureStatusCell>
              {feature.forBasic && <FeatureStatusCell>{feature.forBasic}</FeatureStatusCell>}
              <FeatureStatusCell>{feature.forGrowth}</FeatureStatusCell>
              <FeatureStatusCell>{feature.forExpert}</FeatureStatusCell>
            </TableRow>
          ))}
        </Fragment>
      ))}
    </tbody>
  );
};

const HeaderText = styled.th({
  textWrap: "nowrap",
  paddingTop: 24,
  paddingBottom: 24,
  textAlign: "left",
});

const TableRow = styled.tr(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
}));

const FeatureTextCell = styled.td(({ theme }) => ({
  paddingTop: 16,
  paddingBottom: 16,

  borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
}));

const FeatureText = styled(Flex)<{ hasTooltip: boolean }>(({ hasTooltip }) => ({
  alignItems: "center",
  gap: 4,
  width: "fit-content",
  ...(hasTooltip && {
    textDecoration: "underline dashed",
    textDecorationThickness: "1px",
    textUnderlineOffset: "2px",
  }),
}));

const FeatureStatusCell = styled.td(({ theme }) => ({
  paddingTop: 16,
  paddingBottom: 16,
  textAlign: "center",
  verticalAlign: "middle",
  borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
}));

export default SimplePlanComparisonTable;
